export const ADD = 'ADD';
export const UPDATE = 'UPDATE';
export const FILL = 'FILL';
export const CLOSE = 'CLOSE';
export const SUBSCRIBE = 'SUBSCRIBE';
export const OPTIONS = 'OPTIONS';

// Used when updating the URL
export const INSERT = 'INSERT';
export const REFRESH = 'REFRESH';



// WEBPACK FOOTER //
// ./resources/assets/js/view-stack/store/mutation-types.js